// extracted by mini-css-extract-plugin
export default {"title":"Comp_title__613AF","header":"Comp_header__w6-g0","string":"Comp_string__q3HDd"};